"use client"

import { useEffect, useState } from "react"
import API from "../services/api"
import { io } from "socket.io-client"
import "./LoisirsClient.css"

const socket = io("https://server-deploy-aq8t.onrender.com")

const LoisirsClient = () => {
  const [loisirs, setLoisirs] = useState([])
  const [selectedLoisir, setSelectedLoisir] = useState(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [reservationData, setReservationData] = useState({
    name: "",
    from: "",
    to: new Date().toISOString().split("T")[0], // today's date
    people: 1,
  })

  // Function to format time from datetime
  const formatTimeOnly = (dateString) => {
    if (!dateString) return "Non défini"
    const date = new Date(dateString)
    return date.toLocaleTimeString("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
  }

  const handleReservationSubmit = async () => {
    try {
      await API.post("/reservations", reservationData)
      alert("Réservation créée avec succès !")
      setShowModal(false)
      setReservationData({ name: "", from: "", to: "", people: 1 })
    } catch (error) {
      console.error("Erreur de réservation:", error)
      alert("Erreur lors de la création de la réservation.")
    }
  }

  const fetchLoisirs = async () => {
    try {
      setIsLoading(true)
      const res = await API.get("/loisirs")
      setLoisirs(res.data)
      setIsLoaded(true)
    } catch (error) {
      console.error("Erreur chargement des loisirs:", error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchLoisirs()

    // Force a re-render after a short delay to ensure visibility
    const timer = setTimeout(() => {
      setIsLoaded(true)
    }, 100)

    socket.on("loisirCreated", (newLoisir) => {
      setLoisirs((prev) => [...prev, newLoisir])
    })

    socket.on("loisirUpdated", (updatedLoisir) => {
      setLoisirs((prev) => prev.map((l) => (l._id === updatedLoisir._id ? updatedLoisir : l)))
    })

    socket.on("loisirDeleted", (deletedId) => {
      setLoisirs((prev) => prev.filter((l) => l._id !== deletedId))
    })

    return () => {
      socket.off("loisirCreated")
      socket.off("loisirUpdated")
      socket.off("loisirDeleted")
      clearTimeout(timer)
    }
  }, [])

  return (
    <div className="hotel-app4">
      <style jsx>{`
        .time-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 12px;
          padding: 8px 12px;
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          border-radius: 8px;
          border-left: 4px solid #3b82f6;
          font-size: 0.875rem;
        }

        .time-item {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #475569;
          font-weight: 500;
        }

        .time-icon {
          font-size: 1rem;
          color: #3b82f6;
        }

        .time-value {
          color: #1e293b;
          font-weight: 600;
          font-family: 'Courier New', monospace;
          background: #ffffff;
          padding: 2px 6px;
          border-radius: 4px;
          border: 1px solid #e2e8f0;
        }

        .time-separator {
          color: #94a3b8;
          font-weight: 400;
          margin: 0 4px;
        }

        .detail-time-info {
          background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
          border-radius: 12px;
          padding: 16px;
          margin: 20px 0;
          border-left: 5px solid #3b82f6;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }

        .detail-time-title {
          font-size: 1.1rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .detail-time-content {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          flex-wrap: wrap;
        }

        .detail-time-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
          padding: 12px 16px;
          background: #ffffff;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          min-width: 120px;
        }

        .detail-time-label {
          font-size: 0.875rem;
          color: #64748b;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .detail-time-value {
          font-size: 1.25rem;
          color: #1e293b;
          font-weight: 700;
          font-family: 'Courier New', monospace;
        }

        .time-status {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .status-open {
          background: #dcfce7;
          color: #166534;
        }

        .status-closed {
          background: #fef2f2;
          color: #991b1b;
        }

        .status-unknown {
          background: #f1f5f9;
          color: #475569;
        }

        @media (max-width: 768px) {
          .time-info {
            flex-direction: column;
            gap: 8px;
            align-items: stretch;
          }

          .time-item {
            justify-content: space-between;
          }

          .detail-time-content {
            flex-direction: column;
            gap: 12px;
          }

          .detail-time-item {
            min-width: 100%;
          }
        }
      `}</style>

      <header className="app-header">
        <a href="/SolutionHotel/Home" className="header-back-link">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 12H5M5 12L12 19M5 12L12 5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Retour
        </a>
        <div className="logo-container">
          <img src="/SolutionHotel/images/logo2.png" alt="Hotel Logo" className="logo" />
        </div>
        <div></div> {/* Empty div for flex spacing */}
      </header>

      <main className="app-main">
        <div className="welcome-banner">
          <h1>
            <span>Services</span> & Loisirs
          </h1>
          <p>Découvrez nos activités et divertissements pour tous les âges</p>
        </div>

        <div className="content-container">
          {isLoading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Chargement des services...</p>
            </div>
          ) : loisirs.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">🔍</div>
              <h3>Aucun service trouvé</h3>
              <p>Revenez bientôt pour découvrir nos activités</p>
            </div>
          ) : selectedLoisir ? (
            <div className="spa-detail-view">
              <button className="back-to-list" onClick={() => setSelectedLoisir(null)}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19 12H5M5 12L12 19M5 12L12 5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Retour à la liste
              </button>

              <div className="spa-detail-content">
                <div className="spa-detail-image-container">
                  <img
                    src={selectedLoisir.image || "/placeholder.svg"}
                    alt={selectedLoisir.name}
                    className="spa-detail-image"
                    onError={(e) => {
                      e.target.src = `/placeholder.svg?height=300&width=500&text=${selectedLoisir.name}`
                    }}
                  />
                </div>

                <div className="spa-detail-info">
                  <h2 className="spa-detail-name">{selectedLoisir.name}</h2>
                  <div className="spa-detail-description">
                    <p>{selectedLoisir.description || "Pas de description disponible."}</p>
                  </div>

                  <div className="detail-time-info">
                    <div className="detail-time-title">
                      <span className="time-icon">🕒</span>
                      Horaires d'ouverture
                    </div>
                    <div className="detail-time-content">
                      <div className="detail-time-item">
                        <span className="detail-time-label">Ouverture</span>
                        <span className="detail-time-value">{formatTimeOnly(selectedLoisir.ouverture)}</span>
                      </div>
                      <div className="detail-time-item">
                        <span className="detail-time-label">Fermeture</span>
                        <span className="detail-time-value">{formatTimeOnly(selectedLoisir.fermeture)}</span>
                      </div>
                    </div>
                  </div>

                  <div className="spa-features">
                    <div className="spa-feature-item">
                      <span className="feature-icon">✓</span>
                      <span>Activité encadrée</span>
                    </div>
                    <div className="spa-feature-item">
                      <span className="feature-icon">✓</span>
                      <span>Matériel fourni</span>
                    </div>
                    <div className="spa-feature-item">
                      <span className="feature-icon">✓</span>
                      <span>Pour tous niveaux</span>
                    </div>
                    <div className="spa-feature-item">
                      <span className="feature-icon">✓</span>
                      <span>Réservation recommandée</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={`content-grid ${isLoaded ? "loaded" : ""}`}>
              {loisirs.map((loisir, index) => (
                <div
                  key={loisir._id}
                  className="content-item"
                  style={{ animationDelay: `${index * 0.05}s` }}
                  onClick={() => setSelectedLoisir(loisir)}
                >
                  <div className="content-item-image">
                    <img
                      src={loisir.image || "/placeholder.svg"}
                      alt={loisir.name}
                      onError={(e) => {
                        e.target.src = `/placeholder.svg?height=120&width=300&text=${loisir.name}`
                      }}
                    />
                    <div className="content-item-overlay">
                      <span className="view-details">Voir détails</span>
                    </div>
                  </div>
                  <div className="content-item-content">
                    <h3>{loisir.name}</h3>
                    <p>{loisir.description}</p>

          

                    <div className="content-item-arrow">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 4L20 12L12 20M4 12H20"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {showModal && (
          <div className="modal-backdrop">
            <div className="modal">
              <h2>Réserver une activité</h2>
              <input
                type="text"
                placeholder="Nom"
                value={reservationData.name}
                onChange={(e) => setReservationData({ ...reservationData, name: e.target.value })}
                required
              />
              <input
                type="datetime-local"
                value={reservationData.from}
                onChange={(e) => setReservationData({ ...reservationData, from: e.target.value })}
                required
              />
              <input
                type="number"
                min="1"
                placeholder="Nombre de personnes"
                value={reservationData.people}
                onChange={(e) => setReservationData({ ...reservationData, people: e.target.value })}
                required
              />
              <div className="modal-actions">
                <button onClick={handleReservationSubmit}>✅ Réserver</button>
                <button onClick={() => setShowModal(false)}>❌ Annuler</button>
              </div>
            </div>
          </div>
        )}
      </main>

    
      <footer className="app-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Contact</h4>
            <p>+216 00 000 000</p>
            <p>info@hoteltunis.com</p>
          </div>
          <div className="footer-section">
            <h4>Adresse</h4>
            <p>Avenue de la Promenade</p>
            <p>Tunis, Tunisie</p>
          </div>
          <div className="footer-section">
            <h4>Réservations</h4>
            <p>+216 00 000 000</p>
            <p>reservations@hoteltunis.com</p>
          </div>
          <div className="footer-section">
            <h4>Wi-Fi</h4>
            <p>Réseau: HOTEL_GUEST</p>
            <p>Mot de passe: Disponible à la réception</p>
          </div>
          <div className="footer-section">
            <h4>Suivez-nous</h4>
            <div className="social-links">
              <a href="#" aria-label="Facebook">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="#" aria-label="Instagram">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a href="#" aria-label="Twitter">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>
            © {new Date().getFullYear()} Hotel Tunis. Tous droits réservés.
            <br />
            Créé par{" "}
            <a href="https://www.itbafa.com" target="_blank" rel="noopener noreferrer">
              <img
                src="/SolutionHotel/images/itbafa_logo_white.png"
                alt="ITBAFA Logo"
                style={{ height: "20px", verticalAlign: "middle", marginLeft: "5px" }}
              />
            </a>
          </p>
        </div>
      </footer>
    </div>
  )
}

export default LoisirsClient
